"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = void 0;
const _imports_1 = require("./_imports");
const _shared_1 = require("./_shared");
// Zod schemas for PurchasePercentageRate.Config
const PointerConfigSchema = _imports_1.z.object({
    method: _imports_1.z.string(),
});
// Note: ResolvedPointerConfig includes pointerImplementation (a function),
// which cannot be serialized to JSON. For Wire schema, we only need method.
const FormulaSchema = _imports_1.z.object({
    type: _imports_1.z.literal('formula'),
    config: _shared_1.FormulaConfigSchema,
});
const PointerMethodSchema = _imports_1.z.object({
    type: _imports_1.z.literal('pointer'),
    config: PointerConfigSchema.extend({
        // pointerImplementation is a function, use z.any() for JSON schema
        pointerImplementation: _imports_1.z.any().optional(),
    }),
});
exports.ConfigSchema = _imports_1.z.discriminatedUnion('type', [
    FormulaSchema,
    PointerMethodSchema,
]);
//# sourceMappingURL=PurchasePercentageRate.js.map